import * as types from './mutation_types'
import {UPDATE_CARD_COVER_DATA} from "./mutation_types";
// import getters from "./getters"

export default {
  [types.PUSH_LIST_OF_CALLED_API] (state, payload) {
    const index = state.listOfCalledAPI.indexOf(payload)
    if (index < 0) state.listOfCalledAPI.push(payload)
  },
  [types.UPDATE_DISPLAY_CATE_DATA] (state, payload) {
    state.displayCateData = payload
  },
  [types.UPDATE_DISPLAY_DATA] (state, payload) {
    if (payload.length > 0) {
      state.displayData = state.displayData.concat(payload)
      state.isUpdatedDisplayData = true
      setTimeout(() => state.isUpdatedDisplayData = false)
    }
  },
  [types.UPDATE_DISPLAY_PAGE] (state, payload) {
    if (!state.displayPage.includes(payload)) state.displayPage.push(payload)
  },
  [types.UPDATE_VIDEO_DATA] (state, payload) {
    state.videoData = payload
  },
  [types.UPDATE_GORILLA_CHART_DATA] (state, payload) {
    state.gorillaChartData[payload.key] = payload.data
  },
  [types.UPDATE_CARD_CORP_DATA] (state, payload) {
    state.cardCorpData = payload
  },
  [types.UPDATE_CARD_CORP_EVENT_DATA] (state, payload) {
    state.cardCorpEventData = payload
  },
  [types.UPDATE_CARD_DATA_FOR_SEARCH] (state, payload) {
    state.cardDataForSearch[payload.key] = payload.value
  },
  [types.UPDATE_CARD_DATA_QUERY_AND_RESULT] (state, payload) {
    state.cardDataQueryAndResult = payload
  },
  [types.UPDATE_BENEFIT_DATA_DEPTH] (state, payload) {
    state.benefitDataDepth = payload
  },
  [types.UPDATE_BENEFIT_DATA_FLAT] (state, payload) {
    state.benefitDataFlat = payload
  },
  [types.UPDATE_CARD_COVER_DATA] (state, payload) {
    state.cardCoverData = payload
  },
  [types.CHANGE_OPEN_COMPARE_SLOT] (state, payload) {
    state.openCompareSlot = payload
  },
  [types.CHANGE_SIZE_COMPARE_SLOT] (state, payload) {
    state.bigCompareSlot = payload
  },
  [types.CHANGE_SIZE_TOAST_BANNER] (state, payload) {
    state.smallToastBanner = payload
  },
  [types.UPDATE_COMPARE_SLOT_DATA] (state, payload) {
    state.compareSlotData = payload
  },
  [types.UPDATE_COMPARE_RCMD_MODAL] (state, payload) {
    state.compareRcmdModal = payload
  },
  [types.UPDATE_COMPARE_SLOT_POSITION] (state, payload) {
    state.bigCompareSlotPosition = payload
  },
  [types.UPDATE_CURRENT_CHART_TITLE] (state, payload) {
    state.currentChartTitle = payload
  },
  [types.CHANGE_OPEN_ALL_CHART_DIALOG] (state, payload) {
    state.openAllChartDialog = payload
  },
  [types.CHANGE_OPEN_AWD1_DIALOG] (state, payload) {
    state.openAwd1Dialog = payload
  },
  [types.CHANGE_OPEN_AWD2_DIALOG] (state, payload) {
    state.openAwd2Dialog = payload
  },
  [types.CHANGE_OPEN_AWD3_DIALOG] (state, payload) {
    state.openAwd3Dialog = payload
  },
  [types.CHANGE_OPEN_AWD4_DIALOG] (state, payload) {
    state.openAwd4Dialog = payload
  },
  [types.CHANGE_OPEN_AWD5_DIALOG] (state, payload) {
    state.openAwd5Dialog = payload
  },
  [types.CHANGE_OPEN_SPE1_DIALOG] (state, payload) {
    state.openSpe1Dialog = payload
  },
  [types.CHANGE_OPEN_SPE2_DIALOG] (state, payload) {
    state.openSpe2Dialog = payload
  },
  [types.CHANGE_OPEN_SPE3_DIALOG] (state, payload) {
    state.openSpe3Dialog = payload
  },
  [types.CHANGE_OPEN_SPE4_DIALOG] (state, payload) {
    state.openSpe4Dialog = payload
  },
  [types.CHANGE_OPEN_RETURN1_DIALOG] (state, payload) {
    state.openReturn1Dialog = payload
  },
  [types.CHANGE_OPEN_RETURN2_DIALOG] (state, payload) {
    state.openReturn2Dialog = payload
  },
  [types.CHANGE_OPEN_RETURN3_DIALOG] (state, payload) {
    state.openReturn3Dialog = payload
  },
  [types.CHANGE_OPEN_RETURN4_DIALOG] (state, payload) {
    state.openReturn4Dialog = payload
  },
  [types.CHANGE_OPEN_CHECK_DIALOG] (state, payload) {
    state.openCheckDialog = payload
  },
  [types.CHANGE_OPEN_BRAND_DIALOG] (state, payload) {
    state.openBrandDialog = payload
  },
  [types.CHANGE_OPEN_KBCORP_DIALOG] (state, payload) {
    state.openKBcorpDialog = payload
  },
	[types.CHANGE_OPEN_SHARE_DIALOG] (state, payload) {
    state.openShareDialog = payload
  },
	[types.CHANGE_OPEN_SHARE2_DIALOG] (state, payload) {
    state.openShare2Dialog = payload
  },
	[types.CHANGE_OPEN_FAQ_DIALOG] (state, payload) {
    state.openFaqDialog = payload
  },
	[types.CHANGE_OPEN_FOOTER_DIALOG] (state, payload) {
    state.openFooterDialog = payload
  },
	[types.CHANGE_OPEN_SHORTS1_DIALOG] (state, payload) {
    state.openShorts1Dialog = payload
  },
	[types.CHANGE_OPEN_SHORTS2_DIALOG] (state, payload) {
    state.openShorts2Dialog = payload
  },
	[types.CHANGE_OPEN_SHORTS3_DIALOG] (state, payload) {
    state.openShorts3Dialog = payload
  },
	[types.CHANGE_OPEN_SHORTS4_DIALOG] (state, payload) {
    state.openShorts4Dialog = payload
  },
	[types.CHANGE_OPEN_SHORTS5_DIALOG] (state, payload) {
    state.openShorts5Dialog = payload
  },
  [types.UPDATE_CURRENT_CALENDAR_LABEL] (state, payload) {
    state.currentCalendarLabel = payload
  },
  [types.CHANGE_OPEN_CALENDAR_DIALOG] (state, payload) {
    state.openCalendarDialog = payload
  },
  [types.UPDATE_CURRENT_TEAM] (state, payload) {
    state.currentTeam = payload
  },
  [types.UPDATE_CURRENT_TEAM_CHART_DATA] (state, payload) {
    state.currentTeamChartData[payload.key] = payload.value
  },
  [types.UPDATE_CURRENT_TEAM_CARD_DATA] (state, payload) {
    state.currentTeamCardData[payload.key] = payload.value
  },
  [types.UPDATE_CURRENT_TEAM_EVENT_DATA] (state, payload) {
    state.currentTeamEventData[payload.key] = payload.value
  },
  [types.UPDATE_CURRENT_EVENT_DATA] (state, payload) {
    state.currentEventData[payload.key] = payload.value
  },
  [types.UPDATE_OPEN_DROPDOWN] (state, payload) {
    state.openTeamDropdown = payload
  },
  [types.UPDATE_CURRENT_CONTENTS_DATA] (state, payload) {
    state.currentContentsData = payload
  },
  [types.UPDATE_CURRENT_CARD] (state, payload) {
    state.currentCard = payload
  },
  [types.CHANGE_SLOT_INDEX] (state, payload) {
    state.slotIndex = payload
  },
  SET_EVENT_LAYER_OPEN (state, payload) {
    state.eventLayerOpen = payload
  },
  SET_EVENT_LAYER_DETAIL (state, payload) {
    state.eventLayerDetail = payload
  },
}
